export const sanitizePastedNumeric = (raw: string, dropFraction = false): string => {
  const s = raw.trim().replace(/[^\d.,-]+/g, "");

  const lastComma = s.lastIndexOf(",");
  const lastDot = s.lastIndexOf(".");
  const decIdx = Math.max(lastComma, lastDot);

  let intPart = s;
  let decPart = "";

  if (decIdx > -1) {
    intPart = s.slice(0, decIdx);
    decPart = s.slice(decIdx + 1);
  }

  intPart = intPart.replace(/[.,]/g, "");

  if (dropFraction) {
    return intPart.replace(/^0+(?=\d)/, "") || "0";
  }

  decPart = decPart.replace(/[^\d]/g, "");
  const numStr = decPart ? `${intPart}.${decPart}` : intPart;
  return numStr.replace(/^0+(?=\d)/, "") || "0";
};
